<template>
    <b-row>
        <b-col cols="5">
            <div class="oswald text-uppercase">{{ $t('nuevo_abono.zona_seleccionada') }}:</div>
            <span class="h3 mb-4 mb-lg-2 d-flex justify-content-between align-items-end mrgn_txt">
                {{ zona.name }}
            </span>
            <ImagenPanoramica v-if="zona.imagen_panoramica" name="imagen-panoramica" :url="zona.imagen_panorama" title="Imagen panorámica de la zona" v-on:close="() => close()"/>
            <div v-if="zona.imagen && !mostrarCambiarZona" class="mb-3">
                <img v-lazy="zona.imagen"/>
            </div>
            <button v-if="zona.imagen_panoramica" @click="showModal('imagen-panoramica')" type="button" class="h6 button small-button m-0 mrgn_360">VER 360º</button>
            <button class="h6 button small-button m-0 mrgn_ver" @click="volver" :disabled="false">
                <i class="fa fa-redo"></i> {{ $t('nuevo_abono.cambiar') }}
            </button>
            <div class="lightgray-content p-2 mb-2" v-for="(asiento, index) in asientos" :key="index">
                <div class="text-bold mb-2 d-md-flex">
                    <div class="oswald">
                        Asiento {{ ++index }}. 
                        <span v-if="asiento.asiento && asiento.asiento.zona_nombre">{{ asiento.asiento.zona_nombre }}</span>
                    </div>
                    <div class="ml-2">
                        <small v-if="asiento.asiento && asiento.asiento.fila">{{ $t('general.fila') }}: {{ asiento.asiento.fila }} /</small> 
                        <small v-if="asiento.asiento && asiento.asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento.asiento }}</small>
                        <small v-if="asiento.asiento.visibilidad_reducida" class="text-danger">
                            - {{ $t('visibilidad_reducida.nombre') }}
                        </small>
                        <small v-if="asiento.asiento.porcentaje_visibilidad" class="text-danger">
                            : {{ asiento.porcentaje_visibilidad }}%
                        </small>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col cols="7">
            <AsientosLfpComponent 
                :zona="zona" 
                :asientos="asientos" 
                v-on:actualizarDatos="actualizarDatos" 
                v-on:continuar="bloquearAsientos" 
                :can_click="true" 
                :forzar_adyacentes="false"
                @cargado="loading = false"
                stock="1"
            />
        </b-col>
    </b-row>
</template>

<script>
    import AsientosLfpComponent from '@/components/frontend/abonos/nuevo/AsientosLfpComponent';
    import ImagenPanoramica from "@/components/common/ImagenPanoramica";

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                asientos: []
            }
        },
        methods: {
            actualizarDatos(asientos) {
                this.asientos = asientos;
                this.$emit('clickAsiento', this.asientos);
            },
            bloquearAsientos() {

            },
            volver() {
                this.$emit('volver')
            }
        },
        components: {
            AsientosLfpComponent, ImagenPanoramica
        }
    }
</script>

<style scoped>
    .mrgn_360 {
        margin-right: 8px !important;
        height: 52px;
        width: 80px
    }

    .mrgn_ver {
        margin-left: 8px !important;
        height: 52px;
        width: 80px
    }

    @media (max-width: 768px) {
        .mrgn_360 {
            margin-right: auto;
        }

        .mrgn_ver {
            margin-left:auto;
        }
    }
</style>